import React from 'react'
import { useIntl } from 'react-intl'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import {
  NotificationRowLayout,
  NotificationRowLayoutGetRef
} from './notification-row-layout'
import { css } from '@emotion/css'
import imagePath from '../../../images/onboarding/freemium-notification-welcome.png'

export const testIds = {
  container: 'freemium-new-user-notification',
  image: 'freemium-new-user-notification-image',
  docsLink: 'freemium-new-user-notification-docs-link',
  ticketLink: 'freemium-new-user-notification-ticket-link'
}

const NotificationHeader = () => {
  const intl = useIntl()

  return (
    <div
      className={css`
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        align-content: flex-start;
      `}
    >
      <div
        className={css`
          display: flex;
          align-items: center;
          align-content: flex-start;
        `}
      >
        <img
          data-testid="freemium-new-user-notification-image"
          src={imagePath}
          className={css`
            height: 36px;
            width: 36px;
            position: absolute;
            top: 16px;
            left: 16px;
          `}
        />
      </div>
      <Text font="metadataStrong" color="neutral100">
        Michelle&nbsp;
      </Text>
      <Text font="metadata" color="neutral60">
        {intl.formatMessage({
          id: 'detail_notificationFirstTime_fromContrastSecurity'
        })}
      </Text>
    </div>
  )
}

const NotificationBody = () => {
  const intl = useIntl()

  return (
    <div>
      <Text as="div" font="body" color="neutral100">
        {intl.formatMessage({ id: 'detail_notificationFirstTime_hiThere' })}
      </Text>
      <Text as="div" font="body" color="neutral100">
        {intl.formatMessage({ id: 'detail_notificationFirstTime_thanks' })}
      </Text>
      <br />
      <Text as="p" font="body" color="neutral100">
        {intl.formatMessage(
          { id: 'detail_notificationFirstTime_questionsSupport' },
          {
            a: (...msg) => (
              <Link
                testId={testIds.ticketLink}
                href="https://support.contrastsecurity.com/hc/en-us/requests/new?ticket_form_id=360000011243"
                isExternal={true}
                font="body"
              >
                {msg}
              </Link>
            ),
            a2: (...msg) => (
              <Link
                testId={testIds.docsLink}
                href={intl.formatMessage({ id: 'link_home' })}
                isExternal={true}
                font="body"
              >
                {msg}
              </Link>
            )
          }
        )}
      </Text>
      <br />
      <Text as="div" font="body" color="neutral100">
        {intl.formatMessage({ id: 'detail_notificationFirstTime_haveFun' })}
      </Text>
    </div>
  )
}

export interface FreemiumNewUserNotificationProps {
  organizationUuid: string
  index: number
  style: React.CSSProperties
  getRef: NotificationRowLayoutGetRef
}

export function FreemiumNewUserNotification({
  index,
  style,
  getRef
}: FreemiumNewUserNotificationProps) {
  return (
    <NotificationRowLayout
      testId="freemium-new-user-notification"
      index={index}
      style={style}
      getRef={getRef}
      Content={
        <div
          className={css`
            padding: 12px 0 12px 40px;
          `}
        >
          <NotificationHeader />
          <NotificationBody />
        </div>
      }
    />
  )
}
